import { render, staticRenderFns } from "./GroupDetailsTab.vue?vue&type=template&id=e19515fe&scoped=true&"
import script from "./GroupDetailsTab.vue?vue&type=script&lang=js&"
export * from "./GroupDetailsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e19515fe",
  null
  
)

export default component.exports